// extracted by mini-css-extract-plugin
module.exports = {"overlay":"CarouselLightbox_overlay__1K70S","arrow":"CarouselLightbox_arrow__2GH-B"};